export default {
  profile: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/resources/props.js